import { render, staticRenderFns } from "./DateType.vue?vue&type=template&id=d2216b06&"
import script from "./DateType.vue?vue&type=script&lang=js&"
export * from "./DateType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/xbill/public_html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2216b06')) {
      api.createRecord('d2216b06', component.options)
    } else {
      api.reload('d2216b06', component.options)
    }
    module.hot.accept("./DateType.vue?vue&type=template&id=d2216b06&", function () {
      api.rerender('d2216b06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/CustomField/types/DateType.vue"
export default component.exports